<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="addresses"
    :maskFields="maskFields"
    :indexNested="true"
  >
<!-- codigo para limitar o numero de enderecos da pessoa, removendo para testes!!! -->
  <!-- :createButtonDisabled="hasValidAddress()" -->
    <template slot="new" v-if="!readOnly">
      <New
        @entry-created="entryCreated"
        
        :saveAndAddOtherButtonEnabled="saveAndAddOtherButtonEnabled"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  
    <template slot="edit" slot-scope="{ item }" v-if="!readOnly">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="!readOnly">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>
    
  </BaseIndex>
</template>

<script>
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      tableHeaders: [
        { text: "Cidade", align: "left", sortable: true, value: "city.name"},
        { text: "Rua", align: "left", sortable: true, value: "street" },
        { text: "Nº", align: "left", sortable: true, value: "number" },
        { text: "Bairro", align: "left", sortable: true, value: "neighborhood" },
        { text: "CEP", align: "left", sortable: true, value: "postalCode" },
        { text: "Ações", value: "action", sortable: false }
      ],
      maskFields: [
      ]
    };
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  props: {
    addresses: {
      type: Array,
      default: []
    },
    saveAndAddOtherButtonEnabled: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    modelNameSingular: {
      type: String,
      default: "Endereço"
    },
    modelNamePlural: {
      type: String,
      default: "Endereços"
    },
  },
  created() {
  },
  computed: {
  },
  methods: {
    entryUpdated: function(editedEntry){
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(newlyEntry){
      this.addresses.push(newlyEntry);
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(deletedEntry){
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    hasValidAddress: function() {
      if (this.addresses.length > 0) {
        let filtered_addresses = this.addresses.filter(address => address._destroy == false || address._destroy == null)
        if (filtered_addresses.length > 0) {
          return true;
        }
      }
      return false;
    }
  }
};
</script>

<style scoped></style>
